
import { CSSProperties } from "@mui/material";

export const DropzoneThumbsContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

export const DropzoneThumbStyle: CSSProperties = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 130,
    height: 130,
    padding: 5,
    boxSizing: 'border-box'
};

export const DropzoneThumbInnerStyle: CSSProperties = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

export const DropzoneImgStyle: CSSProperties = {
    display: 'block',
    width: 'auto',
    height: '100%'
};